// React Imports
import { useRef , useEffect } from 'react';

// MUI Imports
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Grid,
    FormControl,
    FormLabel,
    Tooltip,
    Divider
} from "@mui/material";

// Icon Imports
import Icon from "../../../components/icon";
import CloseIcon from '@mui/icons-material/Close';

// Custom Component Imports
import CustomTextField from '../../../components/mui/text-field';
import CustomChip from '../../../components/mui/chip';

const TagManagement = ({
    open,
    handleClose,
    data,
    handleDeleteTag,
    handleAddTag,    
    tags,
    tag, 
    setTag,
    hasSaveIndividualPermission,
}) => {    

    const inputRef = useRef(null);

    useEffect(() => {
        if (open) {
          setTimeout(() => {
            if (inputRef.current) {
              inputRef.current.focus();
            }
          }, 100);
        }
      }, [open]);

    return (
        <Dialog
            fullWidth={true}
            maxWidth="sm"
            open={open}
            onClose={() => {
                handleClose()
                setTag('')
            }}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle sx={{ padding: '20px 24px' }}>
                <Typography variant='h3' fontWeight='bold'>{data?.title}</Typography>
            </DialogTitle>
            <Divider />
            <DialogContent>
                <Grid container spacing={5}>
                    {/* {hasSaveIndividualPermission && ( */}
                        {/* <> */}
                            <Grid item xs={3} sx={{display: 'flex', alignItems: 'center'}}>
                                <FormControl>
                                    <FormLabel>Tag Name:</FormLabel>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <CustomTextField 
                                    fullWidth 
                                    placeholder='Enter your desired tag name' 
                                    value = {tag}
                                    inputRef={inputRef}
                                    onChange = {(e)=>setTag(e.target.value)}
                                    />
                            </Grid>
                            <Grid item xs={3}>
                                <Button variant='contained' color='main' onClick={()=>{handleAddTag(tag)}}>Add Tag</Button>
                            </Grid>
                        {/* </> */}
                    {/* )} */}
                    <Grid item xs={3} sx={{display: 'flex', mt: 1}}>
                        <FormControl>
                            <FormLabel>Existing Tags:</FormLabel>
                        </FormControl>
                    </Grid>
                    <Grid item xs={9}>
                        {tags && tags.length > 0 ? (tags.map((tag)=>(
                            <CustomChip 
                            label={tag.tagName}
                            skin='light'
                            color='info'
                            deleteIcon={<Tooltip title='Click to remove tag'><CloseIcon /></Tooltip>}
                            onDelete={ () => handleDeleteTag(tag.tagName) }
                            // {...(hasSaveIndividualPermission && { onDelete: () => handleDeleteTag(tag.tagName) })}
                            sx={{
                                cursor: 'pointer',
                                mr: 2,
                                mb: 2
                            }}
                        />
                        ))):(
                            <Typography variant="body2" sx={{ ml: 2 }}>
                                Add tags
                            </Typography>
                        )}
                        
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions
                sx={{ 
                    display: "flex", 
                    justifyContent: "flex-start", 
                    padding: '20px 24px !important', 
                    boxShadow: `0px -4px 8px rgb(0, 0, 0, 0.1)`, 
                    zIndex: 1 
                }}
                className="dialog-actions-dense"
            >
                <Box>
                    <Button
                    variant="contained"
                    color="info"
                    onClick={() => { 
                        handleClose();
                        setTag('');
                    }}
                    >
                    Close
                    </Button>
                </Box>
                {/* <Box>
                    <Button variant="contained" color='main' onClick={handleClose}>Save Changes</Button>
                </Box> */}
            </DialogActions>
        </Dialog>
    )
}

export default TagManagement